import { InputFormControl } from 'BrokerTsLib/src/components'
import { DiscountType } from 'BrokerTsLib/src/dtos'
import type { FieldArrayWithId } from 'BrokerTsLib/src/rhf'
import { useFieldArray, useFormContext } from 'BrokerTsLib/src/rhf'

import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'

import type { Step4FormValues } from '../Step4'

export const AllianzMeetingRecordForm = () => {
  const { control } = useFormContext<Step4FormValues>()
  const { isDisabled } = useInsuranceParams()

  const { fields } = useFieldArray({ control, name: 'meetingRecord.discounts' })
  const filteredFieldsWithIndex = fields.map((x, index) => [x, index] as [FieldArrayWithId<Step4FormValues, 'meetingRecord.discounts', 'id'>, number])
    .filter(([x]) =>
      x.insuranceCategoryDiscount.discountType == DiscountType.Voucher &&
      (x.discount ?? 0) > 0)

  // obcas pri prvnim renderu po sjednani zustaval jeste tento formular a padalo to. Neumim zatim resit jinak (callback na useEffect ve Step4.tsx nezabral)
  if (!control) return null

  return (
    <FormBody>
      {filteredFieldsWithIndex.map(([x, index]) => (
        <FormRow key={x.id}>
          <InputFormControl
            label={`${x.insuranceCategoryDiscount.name} (${x.discount} %)`}
            name={`meetingRecord.discounts.${index}.voucherCode` as any}
            control={control}
            isDisabled={isDisabled}
          />
        </FormRow>
      ))}
    </FormBody>
  )
}
